import axios from 'axios';
import { COMPLETE_PAYMENT_REDIRECT } from '../routes/constants';

/**
 * @typedef {import('./types/fsui').PaymentMethodDetails} PaymentMethodDetails
 * @typedef {import('./types/fsui').PaymentSummaryList} PaymentSummaryList
 * @typedef {import('./types/fsui').UpdatePaymentMethodBody} UpdatePaymentMethodBody
 * @typedef {import('./types/fsui').UpdatePaymentMethodResponse} UpdatePaymentMethodResponse
 */

export const createPaymentSessionApi = async ({ currencyCode, transactionCategory, addtlReturnParams = '' }) => {
  const prefixedAddtlReturnParams = addtlReturnParams ? `&${addtlReturnParams}` : '';
  const response = await axios.post('/v2/payments/createSession', {
    currencyCode,
    transactionCategory,
    returnUrl: `${window.location.href}${COMPLETE_PAYMENT_REDIRECT}?currencyCode=${currencyCode}${prefixedAddtlReturnParams}`,
  });

  const responseData = response?.data;
  if (!responseData) {
    return null;
  }

  return responseData;
};

export const getPaymentConfigApi = async () => {
  const response = await axios.get('/v2/payments/config');
  return response?.data ?? {};
};

/**
 * Retrieves a summary list of payment methods for the user
 * @returns {Promise<PaymentSummaryList>} The payment methods summary containing active and recent payment methods
 */
export const getPaymentSummaryListApi = async () => {
  const response = await axios.get('/v2/payments');
  return response?.data ?? {};
};

/**
 * Removes a payment method
 * @param {string} paymentMethodId
 * @returns {Promise<boolean>} Resolves when the payment method is successfully removed
 */
export const removePaymentMethod = async (paymentMethodId) => {
  const response = await axios.delete(`/v2/payments/${paymentMethodId}`);
  return response?.status === 204;
};

/**
 * Updates payment method
 * @param {UpdatePaymentMethodBody} payload
 * @returns {Promise<UpdatePaymentMethodResponse>} Resolves when the payment method is successfully updated
 */
export const updatePaymentMethod = async (payload) => {
  const { data: response } = await axios.post('/v2/payments/update', payload);
  return {
    success: response?.success,
    errorMessage: response?.errorMessage || null,
  };
};
